import type {ReactNode} from 'react';
import React from "react";

import {ClaimServices} from "../../../types/travelClaims";
import {Pill} from "../../_layout/Pill";
import TrivioIcon from "../../../assets/trivio.svg";

export function renderClaimService(service: ClaimServices): ReactNode {
    switch (service) {
        case 'MELON_BUSINESS_TRAVEL_CLIENT':
            return <></>;
        case 'OUTLOOK':
            return <></>;
        case 'TRIVIO':
            return <ClaimServiceTrivio />;
        default:
            return <></>;
    }
}

export const ClaimServiceTrivio = () => {
    return (
        <Pill className="bg-trivio-blue">
            <img src={TrivioIcon} alt="Trivio" />
        </Pill>
    );
};